import type { IconData } from '@stacksjs/iconify-core'

export const socialRewardsFlag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.955 12.19h1.52V25.9h-1.52ZM3.045 32h1.53v-7.62h7.62v1.52h1.52v1.53h15.24V25.9h-12.19v-1.52h1.52V12.19h10.67v-1.53h-12.19V9.14h-1.53v13.71H4.575V9.14h10.66V7.62H4.575V6.09h1.52V4.57h-3.05zm3.05-30.48h1.53v3.05h-1.53ZM3.045 0h3.05v1.52h-3.05Zm-1.52 1.52h1.52v3.05h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default socialRewardsFlag
